import { render, staticRenderFns } from "./IconLabelSelect.vue?vue&type=template&id=5240f0fe"
import script from "./IconLabelSelect.vue?vue&type=script&lang=js"
export * from "./IconLabelSelect.vue?vue&type=script&lang=js"
import style0 from "./IconLabelSelect.vue?vue&type=style&index=0&id=5240f0fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports